import React, { useCallback } from 'react'
import IconButton from '@mui/material/IconButton'
import NoteAltIcon from '@mui/icons-material/NoteAlt'
import { EntityDetail } from '@user/store/map/typings'
import { useDialogState } from '@user/utils/useDialogState'
import { EntityNotesFlow } from '@user/components/Notes/EntityNotesFlow'
import { LocationDTO } from '@sales-center/common'
import { ErrorModalState } from '../../DrawerContentsSingle/hooks/useData'

type Props = {
  entityDetails: EntityDetail
  canUpdate: boolean
  serviceLocation: LocationDTO
  setErrorModal: (errorModal: ErrorModalState) => void
}

export function Notes({
  entityDetails,
  canUpdate,
  serviceLocation,
  setErrorModal,
}: Props) {
  const [addOpen, showAdd, hideAdd] = useDialogState()
  const [viewOpen, showView, hideView] = useDialogState()

  const handleViewClick = useCallback(async () => {
    if (canUpdate) {
      showView()
    } else {
      setErrorModal({
        open: true,
        title: 'Notes',
        message: "You don't have permission to perform this action.",
      })
    }
  }, [canUpdate, showView, setErrorModal])

  return (
    <>
      <IconButton
        sx={{
          backgroundColor: '#EAEEF2',
        }}
        size="large"
        onClick={handleViewClick}
      >
        <NoteAltIcon color={'primary'} />
      </IconButton>
      <EntityNotesFlow
        entityId={entityDetails?.id}
        entityType={entityDetails?.entityType}
        externalLocationId={entityDetails?.externalLocationId}
        canUpdate={canUpdate}
        detail={entityDetails}
        addOpen={addOpen}
        viewOpen={viewOpen}
        onCloseAdd={hideAdd}
        onCloseView={hideView}
        onOpenAdd={showAdd}
        onOpenView={showView}
        currentServiceLocation={serviceLocation}
      />
    </>
  )
}
